export const HEALTH_SERVICE = "actuator/health";

export const CUSTODIA_GARANTIA_SERVICE_CONTEXT = "/fiduciario/";